import Selector from "components/selector/selector.component";
import { useContext } from "react";

import { LanguageContext } from "../../../contexts/language.context";
// import { AuthContext } from "../../contexts/auth.context";

import "./language-selector.scss";

const LANGUAGES = {
	en: "English",
	fr: "French",
};

const LanguageSelector = () => {
	const { changeLanguage, language } = useContext(LanguageContext);

	const handleLanguageChange = (value) => {
		changeLanguage(value);
	};
	// const handleLanguageChange = (event) => {

	// 	// event.preventDefault();
	// 	// const { id } = event.target;
	// 	// changeLanguage(id);
	// };

	return (
		<div className="language-select">
			<Selector
				data={["English", "French"]}
				onSelected={handleLanguageChange}
				selected={LANGUAGES[language]}
			/>
			{/* <span
				onClick={handleLanguageChange}
				className={`language-text ${language == "en" && "choosen"}`}
				id="english"
			>
				ENG
			</span>
			<span className="language-seperator">&ensp; |&ensp; </span>
			<span
				onClick={handleLanguageChange}
				className={`language-text ${language == "fr" && "choosen"}`}
				id="french"
			>
				FR
			</span> */}
		</div>
	);
};

export default LanguageSelector;
